import gql from 'graphql-tag'

export const WEBSITE_CREATE = gql`
    mutation createWebsite($input: WebsiteCreateInput!) {
        websiteCreate(input: $input) {
            id
            name
            previewURL
            productionURL
            elementDefinitions
            realmID
            createdAt
            updatedAt
            updatedBy {
                id
                name
            }
        }
    }
`
